import { createFileRoute } from '@tanstack/react-router';
import { assertUnreachable } from '@social-garden/utils/helpers.ts';
import { useSuspenseQuery } from '@apollo/client';
import { campaignDocument } from '@social-garden/api/documents/campaign.ts';
import { campaignReportForCampaignDocument } from '@social-garden/api/documents/campaignReportable.ts';
import { Container, Grid } from '@mui/material';
import { useMemo } from 'react';
import InstagramPostCampaignReport from '@/components/CampaignReport/InstagramPostCampaignReport.tsx';
import InstagramReelCampaignReport from '@/components/CampaignReport/InstagramReelCampaignReport.tsx';
import InstagramStoryCampaignReport from '@/components/CampaignReport/InstagramStoryCampaignReport.tsx';
import YoutubeVideoCampaignReport from '@/components/CampaignReport/YoutubeVideoCampaignReport.tsx';
import TiktokVideoCampaignReport from '@/components/CampaignReport/TiktokVideoCampaignReport.tsx';
import CampaignReportHeader from '@/components/CampaignReport/CampaignReportHeader.tsx';

export const Route = createFileRoute('/_manager/_app/campaigns/$id/report')({
  component: CampaignReport,
});

function CampaignReport() {
  const { id } = Route.useParams();
  const {
    data: { campaign },
  } = useSuspenseQuery(campaignDocument, {
    variables: {
      id,
    },
  });
  const {
    data: { campaignReportForCampaign },
  } = useSuspenseQuery(campaignReportForCampaignDocument, {
    variables: {
      campaignId: id,
    },
  });

  const reportable = useMemo(() => {
    if (!campaignReportForCampaign) {
      return null;
    }

    switch (campaignReportForCampaign.__typename) {
      case 'InstagramReelCampaignReport':
        return <InstagramReelCampaignReport data={campaignReportForCampaign} />;
      case 'InstagramPostCampaignReport':
        return <InstagramPostCampaignReport data={campaignReportForCampaign} />;
      case 'InstagramStoryCampaignReport':
        return (
          <InstagramStoryCampaignReport data={campaignReportForCampaign} />
        );
      case 'TiktokVideoCampaignReport':
        return <TiktokVideoCampaignReport data={campaignReportForCampaign} />;
      case 'YoutubeVideoCampaignReport':
        return <YoutubeVideoCampaignReport data={campaignReportForCampaign} />;
      default:
        assertUnreachable(campaignReportForCampaign);
    }
  }, [campaignReportForCampaign]);

  return (
    <Container maxWidth="xl">
      <Grid container spacing={4}>
        <Grid size={12}>
          <CampaignReportHeader campaign={campaign} />
        </Grid>
        <Grid size={12}>{reportable}</Grid>
      </Grid>
    </Container>
  );
}
